import {useTranslation} from "react-i18next";
import LeftRight from "../../components/ui/LeftRight";
import s1 from "../../assets/images/services/pages/web-application-development/1.avif";
import {webApplicationCardInfo} from "../../constants/data";
import SlideUp from "../../components/ui/SlideUp";
import Contact from "../../components/sections/Contact";
import TechStack from "../../components/sections/TechStack";
import {webApplicationDevelopment} from "../../constants/meta";
import Meta from "../../components/common/Helmet";
import React from "react";

const WebApplicationDevelopment = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={webApplicationDevelopment.title}
        description={webApplicationDevelopment.description}
        canonical={webApplicationDevelopment.canonical}
        keywords={webApplicationDevelopment.keywords}
        ogTitle={webApplicationDevelopment.title}
        ogDescription={webApplicationDevelopment.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto">
        <div className="mt-12">
          <LeftRight
            title={t('webApplicationDevelopmentPage.title')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            subtitle={t('webApplicationDevelopmentPage.subtitle')}
            descriptionList={[
              t('webApplicationDevelopmentPage.approach'),
              t('webApplicationDevelopmentPage.continuousImprovement')
            ]}
            icon={false}
            image={s1}
            imageHoverable={true}
          />
        </div>
      </div>
      <div className="bg-slate-50 bg-cover bg-no-repeat">
        <div className="md:w-theme-container w-mobile-container mx-auto pt-20">
          <LeftRight
            title={t('webApplicationDevelopmentPage.mostAdvantage.advantagesTitle')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            listGroup={t('webApplicationDevelopmentPage.mostAdvantage.list1', { returnObjects: true })}
            secondListGroup={t('webApplicationDevelopmentPage.mostAdvantage.list2', { returnObjects: true })}
            icon={false}
          />
          <LeftRight
            title={t('webApplicationDevelopmentPage.mostAdvantage.advantagesTitle')}
            subtitle={t('webApplicationDevelopmentPage.mostAdvantage.structuredSubtitle')}
            titleClass={'text-gray-900'}
            isLeft={true}
            textPosition={'justify-center'}
            descriptionPosition={'text-center'}
            listGroup={t('webApplicationDevelopmentPage.mostAdvantage.list3', { returnObjects: true })}
            secondListGroup={t('webApplicationDevelopmentPage.mostAdvantage.list4', { returnObjects: true })}
            icon={false}
          />
        </div>
      </div>
      <div className="md:w-theme-container w-mobile-container mx-auto pt-20 pb-3">
        <h2 className={`flex items-center justify-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
          20+ years Experience
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {webApplicationCardInfo.map((item) => (
            <SlideUp key={item.id}>
              <div className="bg-[#08141A] hover:bg-gray-750 transition-all h-auto md:h-60 duration-300 rounded-xl p-6 shadow-lg border border-gray-700 hover:border-blue-400 group">
                <div className="flex items-start gap-4">
                  <div className="flex-1">
                    {/* Title with subtle underline effect */}
                    <h3 className="text-lg text-white mb-3 pb-3 border-b border-gray-700 group-hover:border-blue-400 transition-colors duration-300">
                      {t(`webApplicationDevelopmentPage.${item.translationKey.title}`)}
                    </h3>
                    {/* Description with improved readability */}
                    <p className="text-gray-300 text-lg leading-relaxed">
                      {t(`webApplicationDevelopmentPage.${item.translationKey.description}`)}
                    </p>
                  </div>
                </div>
              </div>
            </SlideUp>
          ))}
        </div>

        <div className="w-full mt-12">
          <h2 className={`flex justify-center items-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14`}>
            {t('webApplicationDevelopmentPage.siteManagement')}
          </h2>
          <div className="text-base mb-3">{t('webApplicationDevelopmentPage.mesoftProvider')}</div>
          <div className="text-base">{t('webApplicationDevelopmentPage.mesoftTeamDescription')}</div>
        </div>
      </div>
      <div className="add-square-bg">
        <TechStack t={t}/>
      </div>
      <div className="add-square-bg">
        <Contact/>
      </div>
    </div>
  );
};

export default WebApplicationDevelopment;